import React from 'react';
import ReactDOM from 'react-dom';

import './styles/app.css';
import Router from './Routes';
//import registerServiceWorker from './utilities/registerServiceWorker';

ReactDOM.render(<Router />, document.getElementById('root'));
// registerServiceWorker(); This isn't working right now
